export default "__VITE_ASSET__CHwrCf4G__"